const type = 'CLOSE_PAYMENT';

const closePayment = () => ({
  type,
});

export { type };
export default closePayment;
